.MediaPlaylist {
  padding-block-start: var(--base-size-36);
  padding-inline: var(--base-size-20);
}

@media screen and (max-width: 63.24rem) {
  .MediaPlaylist {
    width: 100%;
    max-width: 38.625rem;
    margin-inline: auto;
    padding: 0;
  }

  .MediaPlaylist__panelContent :is(h1, h2, h3) + p {
    margin-block-start: var(--base-size-12);
  }
}

.MediaPlaylist__layout {
  display: flex;
  flex-direction: column;
  background: var(--brand-MediaPlaylist-bgColor);
}

.MediaPlaylist__playlist {
  order: 2;
  min-width: 0;
  border-block-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.MediaPlaylist__heading {
  display: flex;
  min-height: var(--base-size-48);
  align-items: center;
  gap: var(--base-size-8);
  padding: var(--base-size-12) var(--base-size-16);
  border-block-end: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  color: var(--brand-color-text-muted);
  font-family: var(--brand-fontStack-monospace);
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
  text-transform: uppercase;
}

.MediaPlaylist__headingLabel {
  margin: 0;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  text-transform: inherit;
}

.MediaPlaylist__headingCounter {
  display: inline-flex;
  align-items: center;
  gap: var(--base-size-8);
  color: var(--brand-color-text-default);
}

.MediaPlaylist__headingCounter::before {
  content: '•';
  color: var(--brand-color-text-muted);
}

.MediaPlaylist__mediaPanels {
  order: 1;
  width: 100%;
  padding: var(--base-size-16);
}

.MediaPlaylist__mediaPanel {
  min-width: 0;
}

.MediaPlaylist__mediaPanel[hidden] {
  display: none;
}

.MediaPlaylist__panel {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-20);
  width: 100%;
}

.MediaPlaylist__panelContent {
  max-width: var(--brand-Prose-lineLength);
}

.MediaPlaylist__media {
  overflow: hidden;
  background-color: var(--base-color-scale-black-0);
}

.MediaPlaylist__media :is(img, picture, video, iframe) {
  display: block;
  width: 100%;
  max-width: 100%;
}

.MediaPlaylist__tablist {
  order: 2;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.MediaPlaylist--overflowItems .MediaPlaylist__tablist {
  max-block-size: calc((3 * var(--base-size-64)) + (6 * var(--base-size-12)));
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-padding-block: var(--base-size-24);
}

.MediaPlaylist__pagination {
  order: 3;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: var(--base-size-12) var(--base-size-16) var(--base-size-16);
  border-block-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.MediaPlaylist__item {
  position: relative;
  min-width: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  min-block-size: calc(var(--base-size-64) + (2 * var(--base-size-12)));
  overflow-x: hidden;
}

.MediaPlaylist__item::before {
  content: '';
  position: absolute;
  inset-block-end: 0;
  inset-inline: 0;
  height: var(--brand-borderWidth-thin);
  transform: scaleY(1);
  transform-origin: 50% 100%;
  background-color: var(--brand-color-border-muted);
  transition: transform var(--brand-animation-duration-fast) ease,
    background-color var(--brand-animation-duration-fast) ease;
}

.MediaPlaylist__item--selected {
  background-color: var(--brand-color-canvas-subtle);
}

.MediaPlaylist__item--selected::before {
  transform: scaleY(2);
  background-color: var(--brand-color-accent-primary);
}

.MediaPlaylist__itemHeading {
  display: block;
  margin: 0;
  color: var(--brand-color-text-muted);
}

.MediaPlaylist__item--selected .MediaPlaylist__itemHeading {
  color: var(--brand-color-text-default);
}

.MediaPlaylist__itemHeadingContent {
  flex: 1 1 auto;
  min-width: 0;
}

.MediaPlaylist__itemHeadingDetails {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-4);
  min-width: 0;
}

.MediaPlaylist__itemHeadingTitle {
  display: -webkit-box;
  color: inherit;
  overflow: hidden;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.MediaPlaylist__tab {
  box-sizing: border-box;
  width: 100%;
  min-block-size: calc(var(--base-size-64) + (2 * var(--base-size-12)));
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  outline: none;
  padding: var(--base-size-12) var(--base-size-16);
}

.MediaPlaylist__tabContent {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  width: 100%;
  gap: var(--base-size-12);
}

.MediaPlaylist__thumbnail {
  display: block;
  flex-shrink: 0;
  width: var(--base-size-112);
  block-size: calc(var(--base-size-64) - var(--brand-borderWidth-thin));
  overflow: hidden;
  aspect-ratio: 16 / 9;
  border-radius: var(--brand-borderRadius-small);
  background-color: var(--brand-color-canvas-subtle);
}

.MediaPlaylist__thumbnail > * {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MediaPlaylist__tab:focus-visible {
  outline: var(--brand-borderWidth-thick) solid var(--brand-color-focus);
  outline-offset: var(--base-size-4);
}

.MediaPlaylist__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--base-size-12);
}

@media screen and (max-width: 63.24rem) {
  .MediaPlaylist__mediaPanels {
    padding-block-end: var(--base-size-24);
  }
}

@media screen and (min-width: 38.625rem) {
  .MediaPlaylist {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}

@media screen and (min-width: 63.25rem) {
  .MediaPlaylist {
    box-sizing: border-box;
    width: 100%;
    max-inline-size: 80rem;
    margin-inline: auto;
    padding: 0;
    border-inline: none;
  }

  .MediaPlaylist__layout {
    --brand-MediaPlaylist-desktopGutter: 3.75rem;
    --brand-MediaPlaylist-sidebarWidth: 27rem;

    display: grid;
    box-sizing: border-box;
    width: 100%;
    grid-template-areas: 'media tabs';
    grid-template-columns: minmax(0, 1fr) minmax(0, var(--brand-MediaPlaylist-sidebarWidth));
    column-gap: var(--brand-MediaPlaylist-desktopGutter);
    padding-inline-start: var(--brand-MediaPlaylist-desktopGutter);
  }

  .MediaPlaylist__playlist {
    grid-area: tabs;
    display: flex;
    flex-direction: column;
    align-self: stretch;
    padding-block-start: calc(var(--base-size-48) + var(--base-size-12));
    border: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  .MediaPlaylist--overflowItems .MediaPlaylist__tablist {
    max-block-size: calc((3 * var(--base-size-64)) + (6 * var(--base-size-20)));
  }

  .MediaPlaylist__mediaPanels {
    grid-area: media;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding-block: var(--base-size-80);
    padding-inline: 0;
  }

  .MediaPlaylist__mediaPanel {
    width: 100%;
  }

  .MediaPlaylist__panel {
    gap: var(--base-size-40);
  }

  .MediaPlaylist__panelContent {
    width: 100%;
  }

  .MediaPlaylist__media {
    width: 100%;
  }

  .MediaPlaylist__media iframe {
    aspect-ratio: 16 / 9;
    border-radius: var(--base-size-6);
  }

  .MediaPlaylist__itemHeadingDetails {
    font-size: var(--brand-text-size-200);
    line-height: var(--brand-text-lineHeight-200);
  }

  .MediaPlaylist__panelContent :is(h1, h2, h3) + p {
    margin-block-start: var(--base-size-12);
  }

  .MediaPlaylist__heading {
    min-height: auto;
    padding-block-start: var(--base-size-24);
    padding-block-end: var(--base-size-12);
    padding-inline-start: var(--base-size-32);
    padding-inline-end: var(--brand-MediaPlaylist-desktopGutter);
  }

  .MediaPlaylist__item {
    min-block-size: calc(var(--base-size-64) + (2 * var(--base-size-20)));
  }

  .MediaPlaylist__tab {
    min-block-size: calc(var(--base-size-64) + (2 * var(--base-size-20)));
    padding-block: var(--base-size-20);
    padding-inline-start: var(--base-size-32);
    padding-inline-end: var(--brand-MediaPlaylist-desktopGutter);
  }

  .MediaPlaylist__tabContent {
    align-items: center;
  }
}

@media screen and (min-width: 80rem) {
  .MediaPlaylist {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  .MediaPlaylist__playlist {
    border-inline-end: 0;
  }
}
